import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "material-icons/iconfont/material-icons.css";
import { Provider } from 'react-redux';
import store from './store';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SecurityRouter from "./common/security-router";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
  <React.StrictMode>
    <BrowserRouter>
      <SecurityRouter/>
      <ToastContainer pauseOnFocusLoss={false} hideProgressBar autoClose={4000} style={{ width: "30%", fontSize: "14px"}}/>
    </BrowserRouter>
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
